import type { AdminFeedbackListItemResponse } from "../../../types/adminTypes";
import { formatDateTime } from "../../../utils/DateUtils";
import Button from "../../ui/Button/Button";
import AdminPillBadge from "../ui/AdminPillBadge";
import { getFeedbackRoleLabel, getFeedbackTypeLabel } from "./adminFeedbackUtils";

type AdminFeedbackTableRowProps = {
  feedback: AdminFeedbackListItemResponse;
  onView: (feedback: AdminFeedbackListItemResponse) => void;
};

const AdminFeedbackTableRow = ({ feedback, onView }: AdminFeedbackTableRowProps) => (
  <tr className="align-top">
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDateTime(feedback.createdAt)}</td>
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">
      <div className="space-y-1">
        <p className="break-all font-semibold">{feedback.email}</p>
        {feedback.userId ? <p className="text-xs text-myteengig-text-muted">User {feedback.userId.slice(0, 8)}</p> : null}
      </div>
    </td>
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">
      <div className="space-y-2">
        <AdminPillBadge>{getFeedbackTypeLabel(feedback.type)}</AdminPillBadge>
        <p className="text-xs text-myteengig-text-muted">{getFeedbackRoleLabel(feedback.respondentRole)}</p>
      </div>
    </td>
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">
      <div className="space-y-1">
        <p className="font-medium">{feedback.gigTitle ?? "Not tied to gig"}</p>
        {feedback.gigRequestId ? <p className="text-xs text-myteengig-text-muted">Request {feedback.gigRequestId.slice(0, 8)}</p> : null}
      </div>
    </td>
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">
      {feedback.rating !== null ? <AdminPillBadge tone="success">{feedback.rating} / 5</AdminPillBadge> : "Not rated"}
    </td>
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">
      <p className="line-clamp-3 max-w-sm text-myteengig-text-muted">{feedback.message}</p>
    </td>
    <td className="px-4 py-4 text-sm text-myteengig-text-primary">
      <Button variant="outline" size="sm" onClick={() => onView(feedback)}>
        View
      </Button>
    </td>
  </tr>
);

export default AdminFeedbackTableRow;
